import * as PIXI from 'pixi.js';

export class Camera {
  public container: PIXI.Container;
  private target: { x: number; y: number } | null = null;
  private followSpeed = 0.05;
  private worldBounds: PIXI.Rectangle;
  private viewBounds: PIXI.Rectangle;

  constructor(worldBounds: PIXI.Rectangle, viewWidth: number, viewHeight: number) {
    this.container = new PIXI.Container();
    // Enable sorting by zIndex
    this.container.sortableChildren = true;
    this.worldBounds = worldBounds;
    this.viewBounds = new PIXI.Rectangle(0, 0, viewWidth, viewHeight);
  }

  public setTarget(target: { x: number; y: number }): void {
    this.target = target;
  }

  public update(): void {
    if (!this.target) return;

    // Calculate desired camera position (center target on screen)
    const desiredX = -this.target.x + this.viewBounds.width / 2;
    const desiredY = -this.target.y + this.viewBounds.height / 2;

    // Clamp camera to world bounds
    const clampedX = Math.max(
      Math.min(desiredX, 0),
      -(this.worldBounds.width - this.viewBounds.width),
    );
    const clampedY = Math.max(
      Math.min(desiredY, 0),
      -(this.worldBounds.height - this.viewBounds.height),
    );

    // Smooth camera movement
    const scale = this.container.scale.x;
    
    // Calculate target screen positions
    const targetScreenX = clampedX * scale;
    const targetScreenY = clampedY * scale;

    this.container.x += (targetScreenX - this.container.x) * this.followSpeed;
    this.container.y += (targetScreenY - this.container.y) * this.followSpeed;
  }

  public snapToTarget(): void {
    if (!this.target) return;

    // Calculate desired camera position (center target on screen)
    const desiredX = -this.target.x + this.viewBounds.width / 2;
    const desiredY = -this.target.y + this.viewBounds.height / 2;

    // Clamp camera to world bounds
    const clampedX = Math.max(
      Math.min(desiredX, 0),
      -(this.worldBounds.width - this.viewBounds.width),
    );
    const clampedY = Math.max(
      Math.min(desiredY, 0),
      -(this.worldBounds.height - this.viewBounds.height),
    );

    // Snap immediately
    // Apply scale factor to convert world coordinates to screen coordinates
    const scale = this.container.scale.x;
    this.container.x = clampedX * scale;
    this.container.y = clampedY * scale;
  }

  public addToWorld(object: PIXI.Container, zIndex?: number): void {
    if (zIndex !== undefined) {
      object.zIndex = zIndex;
    }
    this.container.addChild(object);
    // Sort children to respect z-index values
    this.container.sortChildren();
  }

  public updateViewBounds(width: number, height: number): void {
    this.viewBounds.width = width;
    this.viewBounds.height = height;
  }
}
